/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconClockMinus = createReactComponent("clock-minus", "IconClockMinus", [
  ["path", { d: "M20.477 15.022a9 9 0 1 0 -7.998 5.965", key: "svg-0" }],
  ["path", { d: "M12 7v5l3 3", key: "svg-1" }],
  ["path", { d: "M16 19h6", key: "svg-2" }]
]);

export { IconClockMinus as default };
//# sourceMappingURL=IconClockMinus.js.map
